import React from 'react';
import YouTube from 'react-youtube';

export default function ({ highlightsfeed, eleRef }) {
    return (

        <section className="main_container_block_feeds">
                        <div className="main_block_container_feed">
                           <div className="block_container_feed_heading_text R15_61">
                               {highlightsfeed.title}
                            </div>
                            <div className="content-div-box-artical feed_video_fetal_common_after">
                               <div className="common-day-upload-image fetus_video_container">
                                   <div className="face_day_cover_photo fetal_development_videos21 ">
                                       <span className="clickhere" onClick={()=>{eleRef.playNow()}}>
                                            <span className="icon pause"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/fetali_video.png" alt="logo" className='fatal-video-play' /></span>
                                            <span className="icon play" data-icon-font="&#xe03d;"></span>
                                        </span>
                                        <span className="custom-timer R16_white">00:00</span>
                                        <span className='vidTiming'>{(highlightsfeed && highlightsfeed.data && highlightsfeed.data.videolength)?highlightsfeed.data.videolength:'01:21'}</span>
                                        <div id="custom-seekbar" onClick={(e) => { eleRef.seekbar(e) }}>
                                            <span id="active-bar"></span>
                                        </div>
                                        
                                        <div className='video_dynamic'>
                                        <video preload="yes" id="videodesk" className='desktopVideo'  poster='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mobweek122.webp' width="100%" onTimeUpdate={(e) => { eleRef.playVideo(e) }}>
                                                    {highlightsfeed && highlightsfeed.data && highlightsfeed.data.map((item, idx) => (
                                                    <source id={idx} src={item.videoUrl} type={`video/${item.type}`} />
                                                    
                                                    ))
                                                    }
                                                </video> 

                                        {/* <video preload="yes" id="videodesk" className='desktopVideo'  poster={require('https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mobweek122.webp')} width="100%" onTimeUpdate={(e) => { eleRef.playVideo(e) }}>
                                                    
                                                    <source src="https://cdn.cdnparenting.com/brainbees/apps/demo/parenting_desktopfetal.mp4" type="video/mp4" />

                                                    <source src="http://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/desktopfetal.ogv" type="video/ogv" />
                                                    <source src="http://cdn.cdnparenting.com/articles/wp-content/uploads/2019/videos/desktopfetal.wmv" type="video/wmv" />
                                                    <source src="http://cdn.cdnparenting.com/brainbees/apps/demo/parenting_mobilefetal-crop.webm" type="video/webm" />
                                                </video>  */}
                                        </div>

                                   </div>
                                </div>
                            </div>
                        </div>
                    </section>

    )
}
